import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';
import {AuthManager} from "../../../components/Authentication/AuthManager";

import iconProfile from "static/img/icon-profile.svg";
import iconLogout from "static/img/icon-logout.svg";

import './DashboardHeader.css';

class DashboardHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    }
    this.menuRef = React.createRef();
    this.buttonRef = React.createRef();
    this.authManager = new AuthManager();
  }

  handleClickOutside = (e) => {
    if (this.menuRef && !this.menuRef.current.contains(e.target) && !this.buttonRef.current.contains(e.target) ) {
      this.setState({active: false});
    }
  }

  render(){
    return (
      <header className="DashboardHeader">
        <h3 className="DashboardHeader-title">{this.props.header}</h3>
        {(this.props.period ?
        <ul className="DashboardHeader-navigation">
          <li className="DashboardHeader-navigationItem">
            <div className={"DashboardHeader-navigationItem__link " + (this.props.period === 'current' ? 'active' : '')} onClick={() => this.props.setPeriod('current')} >This month</div>
          </li>
          <li className="DashboardHeader-navigationItem">
            <div className={"DashboardHeader-navigationItem__link " + (this.props.period === 'previous' ? 'active' : '')} onClick={() => this.props.setPeriod('previous')}>Previous month</div>
          </li>
          <li className="DashboardHeader-navigationItem">
            <div className={"DashboardHeader-navigationItem__link " + (this.props.period === 'total' ? 'active' : '')} onClick={() => this.props.setPeriod('total')}>Total</div>
          </li>
        </ul>
        : null
        )}
        <div className="DashboardHeader-user">
          <NavLink to="/dashboard/user" className="DashboardHeader-user__link">
            <img src={this.props.user ? this.props.user.profile.avatar_uri : ""} alt={(this.props.user ? this.props.user.profile.name : '')} className="DashboardHeader-user__image"/>
            <span className="DashboardHeader-user__name">{(this.props.user ? this.props.user.profile.name : '...')}</span>
          </NavLink>
          <button className="DashboardHeader-user__menu" ref={this.buttonRef} onClick={() => (this.setState(prevState => ({active: !prevState.active})))} >
            <ul className={"DashboardHeader-user__menu-list " + (this.state.active ? 'active' : '')} ref={this.menuRef}>
              <li className="DashboardHeader-user__menu-item">
                <NavLink to="/dashboard/user" className="DashboardHeader-user__menu-link">
                  <img src={iconProfile} alt="" className="DashboardHeader-user__menu-linkIcon" />
                  <span className="DashboardHeader-user__menu-linkText">My profile</span>
                </NavLink>
              </li>
              <li className="DashboardHeader-user__menu-item">
                <div className="DashboardHeader-user__menu-link" onClick={()=>this.authManager.logout()}>
                  <img src={iconLogout} alt="" className="DashboardHeader-user__menu-linkIcon" />
                  <span className="DashboardHeader-user__menu-linkText">Log out</span>
                </div>
              </li>
            </ul>
          </button>
        </div>
      </header>
    )
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
}

export default DashboardHeader;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/DashboardHeader/DashboardHeader.js